// extracted by mini-css-extract-plugin
export default {"menu":"yxUfu","editor":"t5IFh","container":"T19kW","dense":"GyXHd","verify":"NUche"};